import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ContactExpertBigIcon extends BaseIcon {
    getChildren = () => {
        return [
            <g transform="translate(-701 -50.242)">
                <circle cx="8" cy="8" r="8" transform="translate(701 50.242)" fill="#2e3f58"/>
                <rect width="2" height="8" rx="1" transform="translate(706 54.242)" fill="#fff"/>
                <rect width="2" height="8" rx="1" transform="translate(710 54.242)" fill="#fff"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 16 16'
}
